// extracted by mini-css-extract-plugin
export var categoryAndPublishdAtWrapper = "index-module--category-and-publishd-at-wrapper--r05nm";
export var contentWrapper = "index-module--content-wrapper--Tzfk8";
export var expertsGroupWrapper = "index-module--experts-group-wrapper--B3WbX";
export var link = "index-module--link--SJm-b";
export var mainImageWrapper = "index-module--main-image-wrapper--WpJ8X";
export var prBadgeWrapper = "index-module--pr-badge-wrapper--vYYwp";
export var providedBySpoanBadgeWrapper = "index-module--provided-by-spoan-badge-wrapper--C9pUp";
export var root = "index-module--root--RcF-8";
export var title = "index-module--title--wf05V";